export const FILE_TYPE_MAP = {
  PICTURE: 'image',
  VIDEO: 'video'
}

export const POSTER_TYPE = {
  ACHIEVEMENT: 'achievement',
  SITE: 'site'
}
